import { Component, OnInit } from '@angular/core';
import { TeamService } from '@core/services/team.service';
import { StateService } from '@core/services/state.service';
import { Sponsor } from '@shared/models/sponsor';

@Component({
  selector: 'team-info-sponsors',
  templateUrl: './team-info-sponsors.component.html',
  styleUrls: ['./team-info-sponsors.component.scss'],
})

export class TeamInfoSponsorsComponent implements OnInit {

  mainSponsors: Sponsor[];
  premiumSponsors: Sponsor[];
  normalSponsors: Sponsor[];

  constructor(private appStateService: StateService,
              private teamService: TeamService) {}

  public ngOnInit() {
    const teamId = this.teamService.getCurrentTeamId();
    if (!teamId) {
      return;
    }
    this.teamService.fetchTeamSponsors(teamId).then(sponsors => this.setSponsors(sponsors));
  }

  public setSponsors(sponsors) {
    this.mainSponsors = sponsors.filter(sp => sp.type === 'main_sponsor');
    this.premiumSponsors = sponsors.filter(sp => sp.type === 'premium_sponsor');
    this.normalSponsors = sponsors.filter(sp => sp.type === 'normal_sponsor');
  }
}
